import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { chartOptions } from '@features/campaign-list/configuration/lci3-mini-chart-options';

type TrendChartProps = {
  values: Parameters<typeof chartOptions>[0];
  height: string;
};

export const TrendChart = (props: TrendChartProps) => {
  return (
    <HighchartsReact
      highcharts={Highcharts}
      containerProps={{ style: { height: props.height, width: '100%' } }}
      options={chartOptions(props.values)}
    />
  );
};
